module.exports = __webpack_public_path__ + "img/c200.4d443a7a.jpg";